import { TextQuestion } from "~/types/questionTypes"

type TextareaFieldProps = {
  value: string | string[]
  question: TextQuestion
  onChange: (newValue: string) => void
  className?: string
}

export const TextareaField = (props: TextareaFieldProps): JSX.Element => {
  const {
    question: { fieldName },
    value,
    onChange,
    className
  } = props

  return (
    <div className={className}>
      <textarea
        className="TextareaField"
        name={fieldName}
        value={value || ""}
        onChange={(event) => {
          onChange(event.target.value)
        }}
      />
    </div>
  )
}
